import React from 'react';
import {  makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import Paper from '@material-ui/core/Paper';
import Skeleton from 'react-loading-skeleton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

// @Components
import SimpleTableHead from './SimpleTableHead';

const useStyles = makeStyles(theme => ({
	root: {
		width: '100%',
	},
	paper: {
		width: '100%',
		marginBottom: theme.spacing(2),
	},
	table: {
		minWidth: 750,
	},
	tableWrapper: {
		overflowX: 'auto',
	},
	tableRow: {
		cursor: 'default',
		'&:hover': {
			'& a': {
				textDecoration: 'underline',
				display: 'inline-block'
			},
			'& th': {
				textDecoration: 'underline',
				cursor: 'pointer'
			}
		},
		'& td': {
			cursor: 'default'
		}
	}
}));

export default function SimpleTable(props) {
	const {
		columns,
		fieldId,
		isLoading,
		order,
		orderBy,
		page,
		rows,
		rowsPerPage,
	} = props;

	const classes = useStyles();


	function buildLoading() {
		let i;
		let loadingList = [];

		for (i = 1; i < 5; i++) {
			loadingList.push((
				<TableRow key={`loading_${i}`}>
					<TableCell padding="checkbox">
						<Skeleton />
					</TableCell>
					{columns.map((headRow, index) => (
						<TableCell key={`${headRow.id}_${index}`}>
							<Skeleton />
						</TableCell>
					))}
				</TableRow>
			))
		}

		return loadingList;
	}

	return (
		<div className={classes.root}>
			<Paper className={classes.paper}>
				<div className={classes.tableWrapper}>
					<Table
						className={classes.table}
						aria-labelledby="tableTitle"
					>
						<SimpleTableHead columns={columns} rowCount={rows.length}/>
						<TableBody>
							{isLoading
								? buildLoading()
								: rows.length
									? rows.map((row, index) => {
										const labelId = `enhanced-table-checkbox-${index}`;

										return (
											<TableRow
												className={classes.tableRow}
												hover
												role="checkbox"
												tabIndex={-1}
												key={row[fieldId]}
											>
												{columns.map((headRow, index) => {
													const rowContent =
														headRow.render
															? headRow.render(row[headRow.id], row)
															: row[headRow.id];

													return (
														<TableCell style={headRow.numeric ? {textAlign: 'right'} : {}} key={`${headRow.id}_${index}`} {...headRow.rowProps}>
															{rowContent}
														</TableCell>
													);
												})}
											</TableRow>
										);
									})
								: (
										<TableRow>
											<TableCell align="center" colSpan={columns.length + 1}>
												No se han encontrado resultados
											</TableCell>
										</TableRow>
									)
							}
						</TableBody>
					</Table>
				</div>
			</Paper>
		</div>
	);
}



// WEBPACK FOOTER //
// ./src/components/tableSimple/index.js